<template>
  <div>
    <!-- <v-img :src="ImageUrl || ''" max-height="300" /> -->
    <input
      :multiple="multiFils"
      type="file"
      ref="file"
      @change="onFileChange"
      style="display: none"
      accept="application/pdf"
    />
    <span
      class="file-upload__image__placeholder hover-pointer"
      :class="{ 'file-upload__image__placeholder--active': ImageUrl }"
      >{{ imageName ? imageName : $t("labels.upload_files") }}</span
    >
    <v-btn
      class="button button--upload"
      small
      text
      @click="$refs.file.click()"
      v-on="$attrs"
      :title="$t('labels.upload_image')"
    >
      <!-- <v-icon dark class="icon-upload"></v-icon> -->
      <span>
        <v-icon v-if="!loading" color="#fff">mdi-cloud-upload</v-icon>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        ></v-progress-circular>
      </span>
    </v-btn>
    <template v-if="!multiple">
      <div v-if="filePath && filePath.path" style="transform: translateY(50px)">
        <v-col class="pa-0" cols="12">
          <a :href="filePath.path" target="_blank">
            <img
              width="40px"
              height="40px"
              :src="require('@/assets/imgs/pdf.png')"
              alt="pdf file"
            />
          </a>
        </v-col>
      </div>
    </template>
    <template v-else>
      <div
        v-if="passingFiles && passingFiles.length > 0"
        style="transform: translateY(50px)"
      >
        <v-row>
          <v-col
            class="pa-0"
            cols="2"
            v-for="(file, index) in passingFiles"
            :key="index"
          >
            <div class="file-container mb-5">
              <a :href="file.path" target="_blank">
                <img
                  width="40px"
                  height="40px"
                  :src="require('@/assets/imgs/pdf.png')"
                  alt="pdf file"
                />
              </a>
              <div class="d-flex">
                <v-icon
                  @click="handleDeleteFile(file, index)"
                  :title="$t('icon.delete')"
                  color="error"
                  >mdi-delete</v-icon
                >
                <v-icon
                  @click="handleEditFile(file, index)"
                  :title="$t('icon.edit')"
                  color="info"
                  >mdi-pencil</v-icon
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>

    <v-dialog v-model="errorDialog" max-width="300" persistent>
      <v-card>
        <v-card-text class="subheading">{{ ImageErrorMsg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetData">{{ $t("button.got_it") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isValidPDfType, isValidImgSize } from "@/utils/validate";
import {
  UpdateMedia,
  StoreData,
  IndexData,
  DeleteMedia,
} from "@/helpers/apiMethods";

export default {
  name: "FileUpload",
  props: {
    reset: {
      type: Boolean,
      default: false,
    },
    reqType: {
      type: String,
      default: "",
    },
    maxSize: {
      type: Number,
      default: 1,
    },
    file_url: {
      type: Object,
      default: () => {},
    },
    files_urls: {
      type: Array,
      default: () => [],
    },
    file_id: {
      default: null,
    },
    file_name: {
      type: String,
      default: "",
    },
    locale: {
      type: String,
      default: "en",
    },
    editCase: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    reset: {
      handler(value) {
        if (value) {
          this.$refs.file.value = "";
          this.imageName = "";
          this.fileId = "";
          this.indexFile = "";
        }
      },
      immediate: true,
    },
    file_url: {
      handler(value) {
        if (value) {
          this.filePath = value;
        }
      },
      immediate: true,
    },
    file_id: {
      handler(value) {
        if (value) {
          this.fileId = value;
        }
      },
      immediate: true,
    },
  },

  computed: {
    ImageErrorMsg() {
      if (this.errorType === "NOT_PDF") {
        return this.$t("validation.file_type");
      } else if (this.errorType === "SIZE") {
        return this.$t("validation.imageSize", { count: this.maxSize });
      }
    },
    multiFils() {
      if (this.multiple) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      imageName: null,
      ImageUrl: null,
      errorDialog: null,
      errorText: "",
      errorType: "",
      absolute: false,
      overlay: false,
      zIndex: 990,
      pdfFile: "",
      filePath: this.file_url,
      loading: false,
      passingFiles: this.files_urls,
      fileId: this.file_id || null,
      indexFile: null,
    };
  },
  methods: {
    handleEditFile(file, index) {
      this.$refs.file.click();
      this.fileId = file.id;
      this.indexFile = index;
    },
    handleDeleteFile(file, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteMedia(file.id).then(() => {
            this.$delete(this.passingFiles, index);
          });
        }
      });
    },
    readImage(pdfFile) {
      if (this.validateSize(pdfFile)) {
        this.imageName = pdfFile.name;
        this.ImageUrl = URL.createObjectURL(pdfFile);

        if (pdfFile) {
          let dataObj = {
            file: pdfFile,
          };

          if (this.fieldName) {
            dataObj.name = this.fieldName;
            this.$emit("fileSelected", dataObj);
          } else {
            this.$emit("fileSelected", dataObj);
          }
          if (this.fileId) {
            this.autoUpdate(dataObj.file);
          }

          // in case page-settings
          if (
            this.fileId === null &&
            !this.multiple &&
            this.reqType === "page-settings"
          ) {
            const formData = new FormData();
            formData.append(this.file_name, pdfFile);
            formData.append("page_name", this.$route.name);
            formData.append("locale", this.locale);
            StoreData({ reqName: "page-settings", data: formData })
              .then((res) => {
                console.log(res);
              })

              .finally(() => {
                this.loading = false;
                this.imageName = null;
                this.resetData();
              });
          }
        }
      }
    },
    resetData() {
      this.$refs.file.value = "";
      this.errorDialog = false;
      setTimeout(() => {
        this.errorType = "";
      }, 300);
    },
    onFileChange(e) {
      if (this.fileId) {
        this.loading = true;
      }
      const files = e.target.files;
      if (files.length > 0) {
        // this.filePath = null;
        if (!this.multiple) {
          if (this.validateType(files[0])) {
            this.readImage(files[0]);
          }
        } else {
          for (let file of files) {
            if (this.validateType(file)) {
              this.readImage(file);
              if (!this.fileId) {
                // in case not update state
                const formData = new FormData();
                formData.append(`${this.file_name}[]`, file);
                formData.append("page_name", this.$route.name);
                formData.append("locale", this.locale);
                StoreData({ reqName: "page-settings", data: formData })
                  .then((res) => {
                    const { setting } = res.data;
                    const item = setting.find(
                      (el) => el.type === this.file_name
                    );
                    this.passingFiles = item.value;
                  })

                  .finally(() => {
                    this.loading = false;
                    this.imageName = null;
                    this.resetData();
                  });
              }
            } else {
              this.loading = false;
            }
          }
        }
      }
    },
    autoUpdate(file) {
      this.loading = true;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("_method", "PUT");
      formData.append("locale", "en");

      UpdateMedia({ param: this.fileId, data: formData })
        .then((res) => {
          const { media } = res.data;
          this.imageName = null;
          this.fileId = null;
          if (!this.multiple) {
            this.filePath = media;
          } else {
            this.passingFiles[this.indexFile] = media;
          }
          this.$emit("ImageUpdated", media);
          this.indexFile = null;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },

    validateSize(file) {
      if (isValidImgSize(file.size, this.maxSize)) {
        return true;
      } else {
        this.errorType = "SIZE";
        this.errorDialog = true;
        return false;
      }
    },
    validateType(file) {
      if (isValidPDfType(file)) {
        return true;
      } else {
        this.errorType = "NOT_PDF";
        this.errorDialog = true;
        return false;
      }
    },
  },
};
</script>
